"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Butler = void 0;
const ai_toolkit_1 = require("@evidenceb/ai-toolkit");
const interfaces_1 = require("./interfaces");
const diagTools_1 = require("./diagTools");
const bandit_manchot_1 = require("@evidenceb/bandit-manchot");
const adaptive_tests_1 = require("@evidenceb/adaptive-tests");
const athena_revision_1 = require("@evidenceb/athena-revision");
const ai_handler_1 = require("@evidenceb/ai-handler");
const ai_handler_2 = require("@evidenceb/ai-handler");
class Butler {
    get aiEnginesConfigs() {
        return this._aiEnginesConfigs;
    }
    set aiEnginesConfigs(value) {
        if (this.listOfAIEnginesId.some((engineId) => !value[engineId]))
            throw new Error(`Missing config for ${this.listOfAIEnginesId.find((engineId) => !value[engineId])}`);
        this._aiEnginesConfigs = value;
    }
    /********************** Constructor ************************************ */
    constructor(moduleId, listAIEngines, aiEnginesConfigs, aiEnginesHistories, args) {
        var _a;
        this.enginesIDs = [];
        this.aiEngineToSampleActivity = interfaces_1.AIEnginesIDs.adaptiveTest;
        this._aiEnginesConfigs = {};
        this.aiEngines = {};
        this.enginesOntologies = {};
        this.enginesHistories = {};
        this.listOfAIEnginesId = [];
        this.isSampleFromInitialTest = false;
        this.moduleId = moduleId;
        this.treat_initListAIEngines(listAIEngines);
        this.aiEnginesConfigs = aiEnginesConfigs;
        this.enginesHistories = aiEnginesHistories;
        //Init information template
        this.studentInformations = {
            zpdesInfo: {
                banditStatesHistoric: [],
                zpdesFullDiag: {},
                rollingScore: {},
                activitySequence: [],
                initialTestActivitySequence: [],
                lockedResources: (_a = args.lockedResources) !== null && _a !== void 0 ? _a : [],
            },
            mmaInfo: {
                permanentState: false,
            },
        };
        //Init logs template
        this.logs = {
            revisionAlgLogs: {},
        };
        //Init item manager
        this.exercicesManager = new ai_toolkit_1.ExercicesManager();
        // Init AIEngines
        if (this.listOfAIEnginesId.includes(interfaces_1.AIEnginesIDs.adaptiveTest)) {
            if (!this.aiEnginesConfigs.adaptiveTest.adaptiveTestDiagnosis) {
                this.initAiEngineWithUpdate(interfaces_1.AIEnginesIDs.adaptiveTest);
                this.set_aiEngineToSampleActivity(interfaces_1.AIEnginesIDs.adaptiveTest);
            }
            else {
                (0, ai_handler_2.initZpdesFromAdaptativeTest)(this.aiEnginesConfigs.zpdes.config.params, this.aiEnginesConfigs.adaptiveTest.adaptiveTestDiagnosis);
                if (this.listOfAIEnginesId.includes(interfaces_1.AIEnginesIDs.revisionAlg)) {
                    this.initZpdesWithRevision();
                }
                else {
                    this.initAiEngineWithUpdate(interfaces_1.AIEnginesIDs.zpdes);
                }
                this.set_aiEngineToSampleActivity(interfaces_1.AIEnginesIDs.zpdes);
            }
        }
        else if (this.listOfAIEnginesId.includes(interfaces_1.AIEnginesIDs.zpdes)) {
            if (this.aiEnginesConfigs.zpdes.config.params["graph"]["initialTest"]) {
                this.isSampleFromInitialTest = true;
            }
            if (this.listOfAIEnginesId.includes(interfaces_1.AIEnginesIDs.revisionAlg)) {
                this.initZpdesWithRevision();
            }
            else {
                this.initAiEngineWithUpdate(interfaces_1.AIEnginesIDs.zpdes);
            }
            this.studentInformations.mmaInfo.permanentState =
                (0, diagTools_1.checkIfAnObjectiveIsClosed)(this.getZpdesInfos().banditStatesHistoric[this.getZpdesInfos().banditStatesHistoric.length - 1], getOntology(this.enginesOntologies, interfaces_1.AIEnginesIDs.zpdes));
            this.set_aiEngineToSampleActivity(interfaces_1.AIEnginesIDs.zpdes);
        }
        else if (this.listOfAIEnginesId.includes(interfaces_1.AIEnginesIDs.cnedAdaptiveTest)) {
            if (!this.aiEnginesConfigs.cnedAdaptiveTest.cnedAdaptiveTestDiag) {
                if (!this.aiEnginesConfigs.cnedAdaptiveTest.cnedAdaptiveTestDiag) {
                    this.initAiEngineWithUpdate(interfaces_1.AIEnginesIDs.cnedAdaptiveTest);
                    this.set_aiEngineToSampleActivity(interfaces_1.AIEnginesIDs.cnedAdaptiveTest);
                }
            }
        }
        //Update information template
        // this.studentInformations = {
        //     banditStatesHistoric: [new DefaultDict(defaultBanditState())],
        // };
    }
    /******************** Utilitary functions ********************** */
    /**
     *
     * @param date
     */
    set_revisionAlg_SimulationDate(date) {
        getEngine(this.aiEngines, interfaces_1.AIEnginesIDs.revisionAlg).set_simulation_date(date);
    }
    /**
     *
     * @param listAIEngines
     */
    treat_initListAIEngines(listAIEngines) {
        for (let item of listAIEngines) {
            this.listOfAIEnginesId.push(this.convert_AITypeToAIEngineId_IfNecessary(item));
        }
    }
    /**
     * convert an un Engine Id wiht an unknown Type either AITye or AIEngineIDs type as a true AIEngineID type engineID
     * @param unknownTypeEngineId
     * @returns the engineId as an AIEngineId well yyped
     */
    convert_AITypeToAIEngineId_IfNecessary(unknownTypeEngineId) {
        var engineIdasAIEngineIdType;
        if (typeof unknownTypeEngineId == typeof ai_handler_1.AIType ||
            Object.values(ai_handler_1.AIType).includes(unknownTypeEngineId)) {
            engineIdasAIEngineIdType =
                interfaces_1.AITypeToAIEnginesIDs[unknownTypeEngineId];
        }
        else {
            engineIdasAIEngineIdType = unknownTypeEngineId;
        }
        return engineIdasAIEngineIdType;
    }
    getAiEngine(engineId) {
        return getEngine(this.aiEngines, engineId);
    }
    /**
     * set aiEngineToSampleActivity
     * @param engineId
     */
    set_aiEngineToSampleActivity(engineId) {
        this.aiEngineToSampleActivity =
            this.convert_AITypeToAIEngineId_IfNecessary(engineId);
    }
    /**
     * set aiEngineToSampleActivity
     * @param engineId
     */
    set_NextAIEngineToSampleActivity(engineId) {
        this.aiEngineToSampleActivity =
            this.convert_AITypeToAIEngineId_IfNecessary(engineId);
    }
    isRevisionAvailable(minAct = 3) {
        let revisionIsAvailable = false;
        try {
            if (this.listOfAIEnginesId.includes(interfaces_1.AIEnginesIDs.revisionAlg)) {
                revisionIsAvailable = getEngine(this.aiEngines, interfaces_1.AIEnginesIDs.revisionAlg).isRevisionAvailable(minAct);
            }
        }
        catch (error) {
            revisionIsAvailable = false; // FIXME, insult Bruno in the german language if this comments still exists
        }
        return revisionIsAvailable;
    }
    addActivityTo_revisionAlgSpace_ifNeeded(banditChange, previousActivity) {
        var itemDate;
        if (previousActivity.timestamp == undefined) {
            itemDate = new Date(Date.now());
        }
        else {
            itemDate = new Date(Number(previousActivity.timestamp));
        }
        this.baseAddActivityTo_revisionAlgSpace_ifNeeded(banditChange, itemDate);
    }
    /**
     * locck element in zpdes for lockl/unlock features
     * @param engineId
     * @param lockedElements
     */
    zpdesLock(lockedElements) {
        getEngine(this.aiEngines, interfaces_1.AIEnginesIDs.zpdes).lock(lockedElements);
    }
    update_and_nextExercise(previousActivity) {
        var _a;
        // check if first sample and if we need to update the AIs
        if (previousActivity) {
            let translatedHistoryItem = this.translateHistoryItem(previousActivity, this.aiEngineToSampleActivity);
            // checks if exo in intialTest and update the exercise manager according to it
            if (this.aiEngineToSampleActivity == interfaces_1.AIEnginesIDs.zpdes &&
                ((_a = this.enginesOntologies.zpdes) === null || _a === void 0 ? void 0 : _a.isExerciseInInitialTest(translatedHistoryItem.exerciseId))) {
                this.exercicesManager.updateHistory("initialTest", translatedHistoryItem.activityId, translatedHistoryItem.exerciseId);
            }
            else
                this.exercicesManager.updateHistory(this.aiEngineToSampleActivity, translatedHistoryItem.activityId, translatedHistoryItem.exerciseId);
            if (!translatedHistoryItem.isInitialTest) {
                this.updateAIEngine(this.aiEngineToSampleActivity, translatedHistoryItem);
            }
            else if (this.aiEngineToSampleActivity == interfaces_1.AIEnginesIDs.zpdes) {
                this.updateZPDESDiagForInitialTest(translatedHistoryItem);
            }
        }
        // if still in initial Test select the next exercise in the list of initialTest data
        if (this.aiEngineToSampleActivity == interfaces_1.AIEnginesIDs.zpdes &&
            this.isSampleFromInitialTest) {
            if (this.enginesOntologies.zpdes) {
                let activityInfo = this.exercicesManager.next_exercice("initialTest", "", this.enginesOntologies.zpdes);
                activityInfo.isModuleFinished = false;
                activityInfo.moduleId = this.moduleId;
                this.manage_event("AIExerciseChosenEvent", activityInfo);
                return activityInfo;
            }
        }
        // if not initial test do regular sampling
        else {
            return this.select_nextExercise_wihtout_initialTest(previousActivity);
        }
    }
    /**
     * check if curriculum finished, change current AIEgnine if needed and sample next exercise
     * @param previousActivity
     * @returns
     */
    select_nextExercise_wihtout_initialTest(previousActivity) {
        var isCurrentAIEngineCurriculumFinished = this.isCurriculumFinished();
        if (isCurrentAIEngineCurriculumFinished) {
            var activityInfo = this.manageAIEngineCurriculumFinished();
            activityInfo.aiEngine = this.aiEngineToSampleActivity;
            return activityInfo;
        }
        else {
            if (this.aiEngineToSampleActivity == interfaces_1.AIEnginesIDs.zpdes &&
                previousActivity) {
                let banditChange = this.compareBanditStates(this.getZpdesInfos().banditStatesHistoric[this.getZpdesInfos().banditStatesHistoric.length - 2], this.getZpdesInfos().banditStatesHistoric[this.getZpdesInfos().banditStatesHistoric.length - 1]);
                if (this.listOfAIEnginesId.includes(interfaces_1.AIEnginesIDs.revisionAlg))
                    this.addActivityTo_revisionAlgSpace_ifNeeded(banditChange, previousActivity);
                //this.getBanditStatesChanged();
            }
            var activityInfo = this.nextExercise();
            activityInfo.isModuleFinished = isCurrentAIEngineCurriculumFinished;
            activityInfo.aiEngine = this.aiEngineToSampleActivity;
            this.manage_event("AIExerciseChosenEvent", activityInfo);
            return activityInfo;
        }
    }
    manageAIEngineCurriculumFinished() {
        var activityInfo = {};
        if (this.aiEngineToSampleActivity == interfaces_1.AIEnginesIDs.adaptiveTest) {
            this.manageATCurriculumFinished(activityInfo);
            this.manage_event("AICurriculumFinishedEvent", activityInfo);
            var newExerciseInfo = this.setZPDESAsCurrentAIEngineAndNextExercise();
            this.manage_event("AIExerciseChosenEvent", newExerciseInfo);
            newExerciseInfo.isModuleFinished = this.isCurriculumFinished();
            return newExerciseInfo;
        }
        else if (this.aiEngineToSampleActivity == interfaces_1.AIEnginesIDs.cnedAdaptiveTest) {
            this.manageCNEDCurriculumFinished(activityInfo);
            this.manage_event("AICurriculumFinishedEvent", activityInfo);
        }
        else if (this.aiEngineToSampleActivity == interfaces_1.AIEnginesIDs.zpdes) {
            activityInfo = this.manageZPDESCurriculumFinished(activityInfo);
            this.manage_event("AICurriculumFinishedEvent", activityInfo);
        }
        return activityInfo;
    }
    manageATCurriculumFinished(activityInfo) {
        activityInfo.diag = this.get_aiEngine_student_diagnosis(interfaces_1.AIEnginesIDs.adaptiveTest);
        (0, ai_handler_2.initZpdesFromAdaptativeTest)(this.aiEnginesConfigs.zpdes.config.params, activityInfo.diag.predictedCompetences);
        if (this.listOfAIEnginesId.includes(interfaces_1.AIEnginesIDs.revisionAlg)) {
            this.initZpdesWithRevision();
        }
        else {
            this.initAiEngineWithUpdate(interfaces_1.AIEnginesIDs.zpdes);
        }
    }
    setZPDESAsCurrentAIEngineAndNextExercise() {
        this.set_aiEngineToSampleActivity(interfaces_1.AIEnginesIDs.zpdes);
        var newExerciseInfo = this.nextExercise();
        return newExerciseInfo;
    }
    manageCNEDCurriculumFinished(activityInfo) {
        activityInfo.diag = this.get_aiEngine_student_diagnosis(interfaces_1.AIEnginesIDs.cnedAdaptiveTest);
        activityInfo.isModuleFinished = true;
    }
    manageZPDESCurriculumFinished(activityInfo) {
        //activityInfo = this.nextExercise();
        activityInfo.diag = this.get_aiEngine_student_diagnosis(interfaces_1.AIEnginesIDs.zpdes);
        activityInfo.isModuleFinished = true;
        return activityInfo;
    }
    /**
     * function to find from an history item the activityId, objectiveId and if exercise is in initialTest
     * @param historyItem
     * @param engineId
     * @returns
     */
    translateHistoryItem(historyItem, engineId) {
        let ontology = this.enginesOntologies[engineId];
        let exerciseId = historyItem.exerciseId;
        let isInitialTest = false;
        var activityId;
        var objectiveId;
        if (ontology === null || ontology === void 0 ? void 0 : ontology.isExerciseInInitialTest(exerciseId)) {
            [activityId, objectiveId] =
                ontology.getInitialTest_ObjectiveId_And_ActivityId();
            isInitialTest = true;
        }
        else {
            activityId = ontology === null || ontology === void 0 ? void 0 : ontology.get_activityID_of_exercice(exerciseId);
            objectiveId = ontology === null || ontology === void 0 ? void 0 : ontology.get_objectiveID_of_activity(activityId);
        }
        return Object.assign(Object.assign({}, historyItem), { activityId: activityId, objectiveId: objectiveId, exerciseId: exerciseId, isInitialTest: isInitialTest });
    }
    /****************** Init functions ******************** */
    /**
     * init Adaptive Tests and update from historyAIEnginesIDs.adaptiveTest
     */
    initAdaptativeTest(butler) {
        butler.aiEngines.adaptiveTest = new adaptive_tests_1.AdaptiveTest(butler.aiEnginesConfigs.adaptiveTest.config, butler.aiEnginesConfigs.adaptiveTest.bo, butler.aiEnginesConfigs.adaptiveTest.min, butler.aiEnginesConfigs.adaptiveTest.max);
        butler.enginesOntologies.adaptiveTest = new ai_toolkit_1.Ontology(butler.aiEnginesConfigs.adaptiveTest.config.params);
    }
    /**
     * init ZPDES
     */
    initZpdes(butler) {
        butler.aiEngines.zpdes = new bandit_manchot_1.ZpdesHssbgGraph(butler.aiEnginesConfigs.zpdes.config);
        butler.enginesOntologies.zpdes = new ai_toolkit_1.Ontology(butler.aiEnginesConfigs.zpdes.config.params);
        butler.update_zpdes_bandit_states_information(getEngine(butler.aiEngines, interfaces_1.AIEnginesIDs.zpdes).get_clean_bandval_state());
        butler.init_ZpdesFullDiag();
        butler.zpdesLock(butler.studentInformations.zpdesInfo.lockedResources);
        //butler.enginesExercicesManagers.zpdes = new ExercicesManager(butler.enginesOntologies.zpdes);
    }
    /**
     * init Revision Alg
     */
    initRevisionAlg(butler) {
        butler.aiEngines.revisionAlg = new athena_revision_1.RevisionAlg(butler.aiEnginesConfigs.revisionAlg.config);
        butler.enginesOntologies.revisionAlg = new ai_toolkit_1.Ontology(butler.aiEnginesConfigs.revisionAlg.config.params);
    }
    /**
     * init CNED Adaptive Tests and update from history
     */
    initCNEDAdaptativeTest(butler) {
        butler.aiEngines.cnedAdaptiveTest = new adaptive_tests_1.CNED_AdaptiveTest(butler.aiEnginesConfigs.cnedAdaptiveTest.config);
        butler.enginesOntologies.cnedAdaptiveTest = new ai_toolkit_1.Ontology(butler.aiEnginesConfigs.cnedAdaptiveTest.config.params);
    }
    /**
     * init AiEngine based on given ID
     * @param engineId AIengine ID
     */
    initAiEngine(engineId) {
        const initAiEnginesDict = {
            [interfaces_1.AIEnginesIDs.zpdes]: this.initZpdes,
            [interfaces_1.AIEnginesIDs.adaptiveTest]: this.initAdaptativeTest,
            [interfaces_1.AIEnginesIDs.revisionAlg]: this.initRevisionAlg,
            [interfaces_1.AIEnginesIDs.cnedAdaptiveTest]: this.initCNEDAdaptativeTest,
        };
        initAiEnginesDict[engineId](this);
    }
    /**
     * init AiEngine and update from history
     */
    initAiEngineWithUpdate(engineId) {
        this.initAiEngine(engineId);
        this.updateAIEngineFromHistory(engineId);
    }
    /**
     *
     */
    initZpdesWithRevision() {
        this.initZpdes(this);
        this.initRevisionAlg(this);
        this.updateZdpdesFromHistoryWithRevision();
    }
    /************* Update functions ********************* */
    /**
     * update AiEngine from previous activity
     * @param engineId
     * @param previousActivity
     */
    generalUpdateAIEngine(engineId, previousActivity) {
        getEngine(this.aiEngines, engineId).update(previousActivity);
    }
    updateAIEngine(engineId, previousActivity, init) {
        const updateAiEnginesDict = {
            [interfaces_1.AIEnginesIDs.zpdes]: this.updateZpdes,
            [interfaces_1.AIEnginesIDs.adaptiveTest]: this.updateAT,
            [interfaces_1.AIEnginesIDs.revisionAlg]: this.updateRevisionAlg,
            [interfaces_1.AIEnginesIDs.cnedAdaptiveTest]: this.updateCnedAT,
        };
        updateAiEnginesDict[engineId](this, previousActivity, init);
    }
    updateZpdes(butler, item, init = false) {
        getEngine(butler.aiEngines, interfaces_1.AIEnginesIDs.zpdes).update(item);
        butler.compareAndUpdateBanditStates(init);
        butler.updateZdpesFullDiag(item);
    }
    updateAT(butler, item) {
        getEngine(butler.aiEngines, interfaces_1.AIEnginesIDs.adaptiveTest).update(item);
    }
    updateCnedAT(butler, item) {
        getEngine(butler.aiEngines, interfaces_1.AIEnginesIDs.cnedAdaptiveTest).update(item);
    }
    updateRevisionAlg(butler, item) {
        getEngine(butler.aiEngines, interfaces_1.AIEnginesIDs.revisionAlg).update(item);
    }
    /**
     * update AiEngine from history
     * @param engineId
     */
    updateAIEngineFromHistory(engineId, init = true) {
        var _a, _b;
        (_a = this.enginesHistories[engineId]) === null || _a === void 0 ? void 0 : _a.forEach((historyItem) => {
            try {
                let translatedHistoryItem = this.translateHistoryItem(historyItem, engineId);
                if (translatedHistoryItem.isInitialTest) {
                    this.exercicesManager.updateHistory("initialTest", translatedHistoryItem.activityId, translatedHistoryItem.exerciseId);
                }
                else {
                    this.exercicesManager.updateHistory(engineId, translatedHistoryItem.activityId, translatedHistoryItem.exerciseId);
                }
                if (!translatedHistoryItem.isInitialTest) {
                    this.updateAIEngine(engineId, translatedHistoryItem, init);
                }
                else if (engineId == interfaces_1.AIEnginesIDs.zpdes) {
                    this.updateZPDESDiagForInitialTest(translatedHistoryItem);
                }
                if (engineId == interfaces_1.AIEnginesIDs.zpdes)
                    this.compareAndUpdateBanditStates(init);
            }
            catch (_a) { }
        });
        if (engineId == interfaces_1.AIEnginesIDs.zpdes && this.isSampleFromInitialTest) {
            this.isSampleFromInitialTest =
                this.exercicesManager.history["initialTest"].length <
                    ((_b = this.enginesOntologies.zpdes) === null || _b === void 0 ? void 0 : _b.initialTestDatas["exercises"].length);
        }
        // {for (let historyItem of this.enginesHistories[engineId]){
        //     this.translateHistoryItem(historyItem);
        //     this.exercicesManager.updateHistory(lastAiEngineId, event.data.activityId, event.data.exerciseId);
        //     getEngine(this.aiEngines, engineId).update(historyItem);
        // }}
        //getEngine(this.aiEngines, engineId).update_history(this.enginesHistories[engineId]);
    }
    /**
     *
     * @param item
     */
    updateZdpdesFromHistoryWithRevision(init = true) {
        var _a;
        // TODO : checkProblems when items are potentially undefined
        var zpdesItemHistory = this.enginesHistories.zpdes;
        if (!zpdesItemHistory) {
            zpdesItemHistory = [];
        }
        for (let item of zpdesItemHistory) {
            try {
                let translatedHistoryItem = this.translateHistoryItem(item, interfaces_1.AIEnginesIDs.zpdes);
                if (translatedHistoryItem.isInitialTest) {
                    this.exercicesManager.updateHistory("initialTest", translatedHistoryItem.activityId, translatedHistoryItem.exerciseId);
                }
                else {
                    this.exercicesManager.updateHistory(interfaces_1.AIEnginesIDs.zpdes, translatedHistoryItem.activityId, translatedHistoryItem.exerciseId);
                }
                this.updateZdpdesWithRevision(translatedHistoryItem, init);
            }
            catch (_b) { }
        }
        if (this.isSampleFromInitialTest) {
            this.isSampleFromInitialTest =
                this.exercicesManager.history["initialTest"].length <
                    ((_a = this.enginesOntologies.zpdes) === null || _a === void 0 ? void 0 : _a.initialTestDatas["exercises"].length);
        }
        this.updateAIEngineFromHistory(interfaces_1.AIEnginesIDs.revisionAlg);
    }
    /**
     *
     * @param item
     */
    updateZdpdesWithRevision(item, init = false) {
        this.updateZpdes(this, item, init);
        let banditChange = this.compareBanditStates(this.getZpdesInfos().banditStatesHistoric[this.getZpdesInfos().banditStatesHistoric.length - 2], this.getZpdesInfos().banditStatesHistoric[this.getZpdesInfos().banditStatesHistoric.length - 1]);
        this.addActivityTo_revisionAlgSpace_ifNeeded(banditChange, item);
    }
    /************* Sample functions ********************* */
    /**
     * return next activity selected by active AIEgine
     * @returns next activity
     */
    nextActivity() {
        return getEngine(this.aiEngines, this.aiEngineToSampleActivity).nextActivity();
    }
    /**
     *
     * @param history
     * @returns activity to be given
     */
    sample_from_history(history = []) {
        let output = this.sampleAIEngineFromHhistory(this.aiEngineToSampleActivity, history);
        var actId = output.activityId;
        if (actId == undefined)
            throw new Error(`actId undeffined`);
        var onto = getOntology(this.enginesOntologies, this.aiEngineToSampleActivity);
        if (onto == undefined) {
            throw new Error(`outology undeffined`);
        }
        if (this.aiEngineToSampleActivity != interfaces_1.AIEnginesIDs.zpdes &&
            this.aiEngineToSampleActivity != interfaces_1.AIEnginesIDs.cnedAdaptiveTest) {
            output.exerciseId = this.exercicesManager.next_exercice(this.aiEngineToSampleActivity, actId, onto);
        }
        return output;
    }
    /**
     * return AiEngine sample from history based on given ID
     * @param engineId
     * @param history
     * @returns
     */
    sampleAIEngineFromHhistory(engineId, history) {
        switch (engineId) {
            case interfaces_1.AIEnginesIDs.zpdes:
                return this.sample_Zpdes_from_history(history);
            case interfaces_1.AIEnginesIDs.adaptiveTest:
                return this.sample_AdaptiveTest_from_history(history);
            case interfaces_1.AIEnginesIDs.revisionAlg:
                return this.sample_RevisionAlg_from_history(history);
            case interfaces_1.AIEnginesIDs.cnedAdaptiveTest:
                return this.sample_CnedAdaptiveTest_from_history(history);
        }
    }
    /**
     *
     * @param engineId
     * @param history
     * @returns
     */
    sample_Zpdes_from_history(history) {
        var historyToUse = history;
        if (history.length > 0) {
            var convertHistory = history[0];
            if (convertHistory.isAdaptiveTest) {
                // Treat case when test is finished and start zpdes
                historyToUse = [];
            }
        }
        var outputZpdes = getEngine(this.aiEngines, interfaces_1.AIEnginesIDs.zpdes).sample_from_history(historyToUse);
        let banditChange = this.compareAndUpdateBanditStates();
        if (history.length > 0) {
            this.updateZdpesFullDiag(history[0]);
        }
        if (this.aiEngines.revisionAlg) {
            this.addActivityTo_revisionAlgSpace_ifNeeded(banditChange, history[0]);
        }
        return outputZpdes;
    }
    /**
     *
     * @param engineId
     * @param history
     * @returns
     */
    sample_RevisionAlg_from_history(history) {
        var outputRevision = getEngine(this.aiEngines, interfaces_1.AIEnginesIDs.revisionAlg).sample_from_history(history);
        return outputRevision;
    }
    /**
     *
     * @param engineId
     * @param history
     * @returns
     */
    sample_AdaptiveTest_from_history(history) {
        var outputAdaptiveTest = getEngine(this.aiEngines, interfaces_1.AIEnginesIDs.adaptiveTest).sample_from_history(history);
        if (outputAdaptiveTest.isModuleFinished) {
            outputAdaptiveTest.diag = this.get_aiEngine_student_diagnosis(interfaces_1.AIEnginesIDs.adaptiveTest);
            (0, ai_handler_2.initZpdesFromAdaptativeTest)(this.aiEnginesConfigs.zpdes.config.params, outputAdaptiveTest.diag.predictedCompetences);
            if (this.listOfAIEnginesId.includes(interfaces_1.AIEnginesIDs.revisionAlg)) {
                this.initZpdesWithRevision();
            }
            else {
                this.initAiEngineWithUpdate(interfaces_1.AIEnginesIDs.zpdes);
            }
            this.set_aiEngineToSampleActivity(interfaces_1.AIEnginesIDs.zpdes);
        }
        return outputAdaptiveTest;
    }
    /**
     *
     * @param engineId
     * @param history
     * @returns
     */
    sample_CnedAdaptiveTest_from_history(history) {
        var outputAdaptiveTest = getEngine(this.aiEngines, interfaces_1.AIEnginesIDs.cnedAdaptiveTest).sample_from_history(history);
        if (outputAdaptiveTest.isModuleFinished) {
            outputAdaptiveTest.diag = getEngine(this.aiEngines, interfaces_1.AIEnginesIDs.cnedAdaptiveTest).get_student_diagnosis();
        }
        return outputAdaptiveTest;
    }
    nextExercise() {
        var activityInfo = this.nextActivity();
        var actId = activityInfo.activityId;
        if (actId == undefined)
            throw new Error(`actId undeffined`);
        var onto = getOntology(this.enginesOntologies, this.aiEngineToSampleActivity);
        if (onto == undefined) {
            throw new Error(`outology undeffined`);
        }
        activityInfo.exerciseId = this.exercicesManager.next_exercice(this.aiEngineToSampleActivity, actId, onto);
        return activityInfo;
    }
    /**
     *
     * @param engineId
     * @returns
     */
    default_sample_aiEngine_from_history(engineId, history) {
        return getEngine(this.aiEngines, engineId).sample_from_history(history);
    }
    manage_event(eventType, eventData) { }
    /************* Diag and information functions ********************* */
    isCurriculumFinished() {
        if (this.aiEngineToSampleActivity == interfaces_1.AIEnginesIDs.zpdes &&
            this.isSampleFromInitialTest) {
            return false;
        }
        else {
            return getEngine(this.aiEngines, this.aiEngineToSampleActivity).isCurriculumFinished();
        }
    }
    /**
     * Get student diag for specified AIEngine
     * @param engineId
     * @returns student diag for AIEngine with engineId
     */
    get_aiEngine_student_diagnosis(engineId) {
        return getEngine(this.aiEngines, engineId).get_student_diagnosis();
    }
    /**
     * Get default full diag, being zpdes full diag
     * @returns full diag for ZDPES
     */
    get_full_diagnostic() {
        return this.get_aiEngine_full_diagnostic(interfaces_1.AIEnginesIDs.zpdes);
    }
    /**
     * Get full diag for specified AIEngine
     * @param engineId
     * @returns full diag for AIEngine with engineId
     */
    get_aiEngine_full_diagnostic(engineId) {
        return getEngine(this.aiEngines, engineId).get_full_diagnostic();
    }
    /**
     *
     * @returns
     */
    currentBanditStates() {
        if (this.getZpdesInfos().banditStatesHistoric) {
            return this.getZpdesInfos().banditStatesHistoric[this.getZpdesInfos().banditStatesHistoric.length - 1];
        }
    }
    /**
     *
     * @returns
     */
    previous_bandit_states() {
        if (this.getZpdesInfos().banditStatesHistoric)
            return this.getZpdesInfos().banditStatesHistoric[this.getZpdesInfos().banditStatesHistoric.length - 2];
    }
    update_zpdes_bandit_states_information(bandit_states) {
        if (this.getZpdesInfos().banditStatesHistoric)
            this.getZpdesInfos().banditStatesHistoric.push(bandit_states);
    }
    /**
     *
     * @returns banditStatesChanges
     */
    compareAndUpdateBanditStates(init = false) {
        let bandit_states = getEngine(this.aiEngines, interfaces_1.AIEnginesIDs.zpdes).get_clean_bandval_state();
        let banditStatesChanges = this.compareBanditStates(this.currentBanditStates(), bandit_states);
        if (!init) {
            this.checkIf_zpdesBanditStates_changed(banditStatesChanges);
        }
        this.update_zpdes_bandit_states_information(bandit_states);
        return banditStatesChanges;
    }
    /**
     * Compare two ZPDES full ssbg bandit states
     * @param bs1
     * states
    :  = [];@param
     * bs2
     * @returns differences between the two ssbg bandit es
     */
    compareBanditStates(bs1, bs2) {
        let banditStatesDiff = {};
        let objOrActId;
        for (objOrActId in bs1) {
            if (bs2[objOrActId] != bs1[objOrActId]) {
                banditStatesDiff[objOrActId] = {
                    previousState: bs1[objOrActId],
                    currentState: bs2[objOrActId],
                };
            }
        }
        return banditStatesDiff;
    }
    /**
     * check if bandit state changed to emit corresponding events
     * @returns
     */
    checkIf_zpdesBanditStates_changed(banditStatesChanges) {
        for (let objOrActId in banditStatesChanges) {
            if (banditStatesChanges[objOrActId].currentState == 2) {
                this.manage_event("AIDeactivationEvent", objOrActId);
                // if (this.enginesOntologies.zpdes?.objectives.includes(objOrActId)) {
                //     if (!this.studentInformations.mmaInfo.permanentState)
                //         this.studentInformations.mmaInfo.permanentState = true;
                // }
            }
            else if (banditStatesChanges[objOrActId].currentState == 1) {
                this.manage_event("AIActivationEvent", objOrActId);
            }
        }
    }
    baseAddActivityTo_revisionAlgSpace_ifNeeded(banditStatesChanges, date) {
        for (const [banditElementId, banditStatesChange] of Object.entries(banditStatesChanges)) {
            if (!getOntology(this.enginesOntologies, interfaces_1.AIEnginesIDs.zpdes).objectives.includes(banditElementId) &&
                banditStatesChange.currentState == 2) {
                let actId = banditElementId;
                let objId = getOntology(this.enginesOntologies, interfaces_1.AIEnginesIDs.zpdes).get_objectiveID_of_activity(actId);
                const diff_act = getOntology(this.enginesOntologies, interfaces_1.AIEnginesIDs.zpdes).computeLinearDifficulties(); //getLinearDiff in ontology
                if (objId) {
                    getEngine(this.aiEngines, interfaces_1.AIEnginesIDs.revisionAlg).add_activity(objId, actId, diff_act[actId], date);
                }
            }
        }
    }
    /**
     *
     * @returns
     */
    getZpdesInfos() {
        return this.studentInformations.zpdesInfo;
    }
    /**
     *
     */
    init_ZpdesFullDiag() {
        const zpdes = getEngine(this.aiEngines, interfaces_1.AIEnginesIDs.zpdes);
        let listObjDiag = [];
        let ontology = getOntology(this.enginesOntologies, interfaces_1.AIEnginesIDs.zpdes);
        for (let obj of ontology.objectives) {
            listObjDiag.push({
                id: obj,
                alert: "none",
                progression: [],
                status: "none",
                timeSpent: 0,
            });
            for (let actId of ontology.activitiesOfObj[obj]) {
                this.getZpdesInfos().rollingScore[actId] = 0.5;
            }
        }
        let thresPos = 0.2;
        let thresNeg = 0.2;
        if (zpdes.params.ZpdesSsbg.ZpdesSsb.dashboard) {
            thresPos = zpdes.params.ZpdesSsbg.ZpdesSsb.dashboard.thresPos;
            thresNeg = zpdes.params.ZpdesSsbg.ZpdesSsb.dashboard.thresNeg;
        }
        this.getZpdesInfos().rollingScore["thresPos"] = thresPos;
        this.getZpdesInfos().rollingScore["thresNeg"] = thresNeg;
        this.getZpdesInfos().zpdesFullDiag = {
            objectives: listObjDiag,
            param_state: getEngine(this.aiEngines, interfaces_1.AIEnginesIDs.zpdes).get_clean_bandval_state(),
            //new_param_state: getEngine(this.aiEngines, AIEnginesIDs.zpdes).get_clean_bandval_state(),
            timeSpent: {},
            mean_student_score: 0,
            graphe_coverage_rate: 0,
        };
    }
    /**
     *
     * @param item
     * @returns
     */
    updateZdpesFullDiag(item) {
        const zpdes = getEngine(this.aiEngines, interfaces_1.AIEnginesIDs.zpdes);
        const ontology = getOntology(this.enginesOntologies, interfaces_1.AIEnginesIDs.zpdes);
        let actId = ontology.get_activityID_of_exercice(item.exerciseId);
        let actIdx = ontology.get_activity_position_in_obj(actId);
        let objId = ontology.get_objectiveID_of_activity(actId);
        let objIdx = ontology.get_objective_position(objId);
        let moduleId = this.moduleId;
        // Add activty to sequence
        this.getZpdesInfos().activitySequence.push({
            moduleId: moduleId,
            objectiveId: objId,
            activityId: actId,
            exerciseId: item.exerciseId,
            score: item.score,
        });
        // Get activity infos if exist, need to check if it is poassed by ref
        let activityFoundInDiag = this.getZpdesFullDiag().objectives[objIdx].progression.find((actInfo) => actInfo.id == actId);
        // Manage bandit status change for unlocking or closing of obj and act
        let banditStatesChanges = {};
        if (this.getZpdesInfos().banditStatesHistoric.length > 1) {
            banditStatesChanges = this.compareBanditStates(this.getZpdesInfos().banditStatesHistoric[this.getZpdesInfos().banditStatesHistoric.length - 2], this.getZpdesInfos().banditStatesHistoric[this.getZpdesInfos().banditStatesHistoric.length - 1]);
        }
        let unlockedObjOrAct = [];
        for (const [banditElementId, banditStatesChange] of Object.entries(banditStatesChanges)) {
            if (banditStatesChange.currentState == 1) {
                // && !getOntology(this.enginesOntologies, AIEnginesIDs.zpdes).objectives.includes(banditElementId)
                if (!ontology.objectives.includes(banditElementId)) {
                    let unlockedObjId = ontology.get_objectiveID_of_activity(banditElementId);
                    let unlockedActIdx = ontology.get_activity_position_in_obj(banditElementId);
                    unlockedObjOrAct.push({
                        id: banditElementId,
                        level: (0, diagTools_1.getZpdesActLevel)(zpdes, unlockedObjId, unlockedActIdx),
                    });
                }
            }
            else if (banditStatesChange.currentState == 2) {
                if (ontology.objectives.includes(banditElementId)) {
                    let objIdxToClose = ontology.get_objective_position(banditElementId);
                    this.getZpdesFullDiag().objectives[objIdxToClose].status =
                        "completed";
                }
                else {
                    let lockedObjId = ontology.get_objectiveID_of_activity(banditElementId);
                    let lockedObjIdx = ontology.get_objective_position(lockedObjId);
                    let activityFoundInDiagToLock = this.getZpdesFullDiag().objectives[lockedObjIdx].progression.find((actInfo) => actInfo.id == banditElementId);
                    if (activityFoundInDiagToLock) {
                        activityFoundInDiagToLock.status = "closed";
                    }
                }
            }
        }
        // Update Rolling Score infos
        let tempRolling_score = this.getZpdesInfos().rollingScore[actId];
        this.getZpdesInfos().rollingScore[actId] =
            0.5 * this.getZpdesInfos().rollingScore[actId] + 0.5 * item.score;
        let actvitySeqSize = 0;
        if (activityFoundInDiag)
            actvitySeqSize = activityFoundInDiag.exercises.length;
        // Define alerts for exercice Diagf
        let alertValues = ["positive", "negative", "none"];
        let computedAlerts = [
            item.score - this.getZpdesInfos().rollingScore[actId] >
                this.getZpdesInfos().rollingScore["thresPos"] && actvitySeqSize > 1,
            item.score - this.getZpdesInfos().rollingScore[actId] <
                -this.getZpdesInfos().rollingScore["thresNeg"] && actvitySeqSize > 1,
        ];
        computedAlerts.push(!computedAlerts[0] && !computedAlerts[1]);
        //Create exercise diag element
        // console.log('act', this.getZpdesInfos().activitySequence, ontology.startWithInitialTest ? this.getZpdesInfos().activitySequence.length - 1 - ontology.initialTestDatas["exercises"].length : this.getZpdesInfos().activitySequence.length - 1,);
        let exDiag = {
            id: item.exerciseId,
            temp_occ: this.getZpdesInfos().activitySequence.length - 1,
            success: {
                current: item.score,
                expected: tempRolling_score,
                alert: alertValues[computedAlerts.indexOf(true)],
            },
            breakPoint: {
                improvement: computedAlerts[0],
                regression: computedAlerts[1],
            },
            unlockedElements: unlockedObjOrAct,
        };
        // Init or update activity progression
        if (!activityFoundInDiag) {
            this.getZpdesFullDiag().objectives[objIdx].progression.push({
                id: actId,
                exercises: [exDiag],
                status: "open",
                level: (0, diagTools_1.getZpdesActLevel)(zpdes, objId, actIdx),
            });
        }
        else {
            activityFoundInDiag.exercises.push(exDiag);
        }
        // Manage timestamp
        let { refDate, duration } = (0, diagTools_1.manageExTimeStamp)(item);
        //Init or update Obj Diag
        if (this.getZpdesFullDiag().objectives[objIdx].progression.length == 1) {
            this.firstUpdateObjDiag(item, objIdx);
        }
        else {
            this.getZpdesFullDiag().objectives[objIdx].timeSpent += duration;
            this.getZpdesFullDiag().objectives[objIdx].alert = (0, diagTools_1.updateObjAlert)(this.getZpdesFullDiag().objectives[objIdx].progression);
        }
        // Update Module diag values
        this.getZpdesFullDiag().mean_student_score = (0, ai_toolkit_1.func_mean)(this.getZpdesInfos().activitySequence.map((act) => act.score));
        //this.getZpdesFullDiag().graphe_coverage_rate = computeGrapheCoverage(zpdes);
        //this.getZpdesFullDiag().graphe_coverage_rate = computeGrapheCoverageBis(zpdes.get_clean_bandval_state(), ontology);
        this.getZpdesFullDiag().graphe_coverage_rate =
            (0, diagTools_1.computeGrapheCoverageDiffDoneMasteredWithInitialTest)(zpdes.get_clean_bandval_state(), ontology, this.getZpdesInfos().activitySequence, this.getZpdesInfos().initialTestActivitySequence);
        this.getZpdesFullDiag().param_state = zpdes.get_clean_bandval_state();
        if (this.getZpdesFullDiag().timeSpent[refDate])
            this.getZpdesFullDiag().timeSpent[refDate] += duration;
        else if (item.timestamp) {
            this.getZpdesFullDiag().timeSpent[refDate] = duration;
        }
    }
    updateZPDESDiagForInitialTest(item) {
        const zpdes = getEngine(this.aiEngines, interfaces_1.AIEnginesIDs.zpdes);
        const ontology = getOntology(this.enginesOntologies, interfaces_1.AIEnginesIDs.zpdes);
        let initialTestData = ontology.getInitialTest_ObjectiveId_And_ActivityId();
        let actId = initialTestData[1];
        let objId = initialTestData[0];
        let moduleId = this.moduleId;
        this.getZpdesInfos().initialTestActivitySequence.push({
            moduleId: moduleId,
            objectiveId: objId,
            activityId: actId,
            exerciseId: item.exerciseId,
            score: item.score,
        });
        this.getZpdesFullDiag().graphe_coverage_rate =
            (0, diagTools_1.computeGrapheCoverageDiffDoneMasteredWithInitialTest)(zpdes.get_clean_bandval_state(), ontology, this.getZpdesInfos().activitySequence, this.getZpdesInfos().initialTestActivitySequence);
    }
    /**
     * Initialyse diag of objectives when first obj activity is done
     * @param item
     * @param objIdx
     */
    firstUpdateObjDiag(item, objIdx) {
        this.getZpdesFullDiag().objectives[objIdx].status = "inProgress";
        let { refDate, duration } = (0, diagTools_1.manageExTimeStamp)(item);
        this.getZpdesFullDiag().objectives[objIdx].timeSpent = duration;
    }
    /**
     *
     * @returns
     */
    getZpdesFullDiag() {
        var _a;
        return (_a = this.getZpdesInfos().zpdesFullDiag) !== null && _a !== void 0 ? _a : {};
    }
}
exports.Butler = Butler;
const getEngine = (engines, engineId) => {
    const engine = engines[engineId];
    if (!engine)
        throw new Error(`${engineId} was not instanciated`);
    return engine;
};
const getOntology = (ontologies, engineId) => {
    const ontology = ontologies[engineId];
    if (!ontology)
        throw new Error(`${engineId} ontology was not instanciated`);
    return ontology;
};
